import { render } from "./Referral_Tokens.vue?vue&type=template&id=18625892"
import script from "./Referral_Tokens.vue?vue&type=script&lang=js"
export * from "./Referral_Tokens.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__